import { useSearchParams } from 'react-router';

const SEARCH_PARAM = 'q';

/**
 * The users-list search term, shared by the page header's input and the list that filters on it.
 * It lives in the URL so it survives following a row's hosts link and coming back; writes replace
 * rather than push, so each keystroke isn't a history entry.
 */
export function useUsersSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get(SEARCH_PARAM) ?? '';
  const setSearch = (value: string) => {
    setSearchParams(
      (params) => {
        if (value) {
          params.set(SEARCH_PARAM, value);
        } else {
          params.delete(SEARCH_PARAM);
        }
        return params;
      },
      { replace: true }
    );
  };
  return [search, setSearch] as const;
}
